export const TEMPLATES_CACHE_TAG = "templates";

export function templateCacheTag(templateIdOrSlug: string) {
  return `template:${templateIdOrSlug}`;
}
